import { render, staticRenderFns } from "./senarai_user.vue?vue&type=template&id=1ecb57ff"
import script from "./senarai_user.vue?vue&type=script&lang=js"
export * from "./senarai_user.vue?vue&type=script&lang=js"
import style0 from "./senarai_user.vue?vue&type=style&index=0&id=1ecb57ff&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports